import { EmployeeValidator } from './employee-validator.base'
import { employeeAPIModel } from 'src/app/models/api.model'
import { EmployeeService } from 'src/app/services/employee/employee.service'
import { WebService } from 'src/app/services/api/web.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'

import {
  EMP_DISPLAY_ID,
  EMPLOYEE_ID,
  FIRST_NAME,
  MIDDLE_NAME,
  LAST_NAME,
  MARITAL_STATUS,
  GENDER,
  DOB as EXCEL_DOB,
  DATE_OF_JOINING,
  PRIMARY_EMAIL_ID,
  SECONDARY_EMAIL_ID,
  AADHAR_NUMBER,
  PAN_NUMBER,
  BANK_ACCOUNT_NUMBER,
  IFSC_CODE,
  PRIMARY_MOBILE_NUMBER,
  SECONDARY_MOBILE_NUMBER,
  AADHAAR_NAME,
  ADVANCE_PAY,
  AREA,
  BASIC_PAY,
  BASIC_WAGES,
  BRANCH,
  CITY,
  COUNTRY,
  COUNTRY_OF_ISSUE,
  CURRENT_PF_ACCOUNT_NUMBER,
  DAILY_HOURS_OF_WORK,
  DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYMENT,
  DATE_OF_JOINING_IN_EPF,
  DATE_OF_LEAVING,
  DESIGNATION,
  DOOR_NO,
  EMPLOYEE_TYPE,
  EPF_APPLICABILITY,
  EPF_WAGES_ON_JOINING,
  EPS,
  EPS_APPLICABILITY,
  ESI_NUMBER,
  FATHER_NAME,
  FOOD_ALLOWANCE,
  GROSS_EARNINGS,
  GROSS_WAGES,
  HIGHER_PENSION_APPLICABILITY,
  HRA,
  INTERNATIONAL_WORKER,
  INTERVALS_OF_REST,
  LOP,
  LTA,
  MONTH_WORKING_DAYS,
  NATIONALITY,
  NATURE_OF_WORK,
  NOMINEE_DOB,
  NOMINEE_NAME,
  NOMINEE_RELATIONSHIP,
  NOTIFICATION_PREFERENCES,
  OVERTIME_WAGES,
  PAN_NAME,
  PASSPORT_NAME,
  PASSPORT_NUMBER,
  PASSPORT_VALIDITY_FROM,
  PASSPORT_VALIDITY_TO,
  PENSION_PAYMENT_ORDER_NUMBER,
  PERQ_ALLOWANCE,
  PF_NUMBER,
  PHYSICALLY_HANDICAP,
  PINCODE,
  REASON_FOR_LEAVING,
  ROLE_CODE,
  SALARY_DUE_NET_SALARY,
  SPECIAL_ALLOWANCE,
  SPOUSE_NAME,
  STATE,
  STATUS,
  STREET,
  TDS,
  TELEPHONE_ALLOWANCE,
  UAN_NUMBER,
  WORKED_DAYS,
  DEPARTMENT,
  LOCATION
} from 'src/app/constants/excel.columns'

import {
  DateValidatorForFutureDate,
  DataValidatorForEmployementType,
  DataValidatorForDDMMYYYY,
  DataValidatorForEmployeeStatus,
  DataValidatorForFirstLetterCaps,
  DataValidatorForGender
} from 'src/app/components/import/validators/validator.functions'

import { removeNullUndefinedEmpty } from 'src/app/services/common/common.service'
import { IColumn } from './abstract-validator.interface'

export class UpdateEmployeeValidator extends EmployeeValidator {
  public override _header: Map<string, IColumn> = new Map([
    ['Display ID', EMP_DISPLAY_ID],
    ['Employee ID', EMPLOYEE_ID],
    ['First Name', { ...FIRST_NAME, validations: [DataValidatorForFirstLetterCaps()] }],
    ['Middle Name', MIDDLE_NAME],
    ['Last Name', { ...LAST_NAME, validations: [DataValidatorForFirstLetterCaps()] }],
    ['Marital Status', MARITAL_STATUS],
    ['Gender', { ...GENDER, validations: [DataValidatorForGender()] }],
    ['DOB', { ...EXCEL_DOB, validations: [DataValidatorForDDMMYYYY(), DateValidatorForFutureDate()] }],
    ['Joining Date', { ...DATE_OF_JOINING, validations: [DataValidatorForDDMMYYYY(), DateValidatorForFutureDate()] }],
    ['Father Name', FATHER_NAME],
    ['Primary Email ID', PRIMARY_EMAIL_ID],
    ['Secondary Email ID', SECONDARY_EMAIL_ID],
    ['Primary Mobile Number', PRIMARY_MOBILE_NUMBER],
    ['Secondary Mobile Number', SECONDARY_MOBILE_NUMBER],
    ['Status', { ...STATUS, validations: [DataValidatorForEmployeeStatus()] }],
    ['Nationality', NATIONALITY],
    ['Role Code', ROLE_CODE],
    ['Notification Preferences', NOTIFICATION_PREFERENCES],
    ['Aadhaar Number', AADHAR_NUMBER],
    ['Aadhaar Name', AADHAAR_NAME],
    ['Pan Number', PAN_NUMBER],
    ['Pan Name', PAN_NAME],
    ['Nominee Name', NOMINEE_NAME],
    ['Nominee Relationship', NOMINEE_RELATIONSHIP],
    ['Nominee DOB', NOMINEE_DOB],
    ['UAN Number', UAN_NUMBER],
    ['PF Number', PF_NUMBER],
    ['Current PF Account Number', CURRENT_PF_ACCOUNT_NUMBER],
    ['Bank Account number', BANK_ACCOUNT_NUMBER],
    ['IFSC Code', IFSC_CODE],
    ['Is International Worker', INTERNATIONAL_WORKER],
    ['Passport Name', PASSPORT_NAME],
    ['Passport Number', PASSPORT_NUMBER],
    ['Passport Validity From', PASSPORT_VALIDITY_FROM],
    ['Passport Validity To', PASSPORT_VALIDITY_TO],
    ['Country Of Issue', COUNTRY_OF_ISSUE],
    ['Designation', DESIGNATION],
    ['Department', DEPARTMENT],
    ['Location', { ...LOCATION, validations: [] }],
    ['Branch', BRANCH],
    ['Is Physically Disabled', PHYSICALLY_HANDICAP],
    ['Basic Wages', BASIC_WAGES],
    ['EPF Wages On Joining', EPF_WAGES_ON_JOINING],
    ['Date Of Leaving', DATE_OF_LEAVING],
    ['Reason For Leaving', REASON_FOR_LEAVING],
    ['EPF Applicability', EPF_APPLICABILITY],
    ['EPS Applicability', EPS_APPLICABILITY],
    ['Gross Wages', GROSS_WAGES],
    ['Type Of Employee', { ...EMPLOYEE_TYPE, validations: [DataValidatorForEmployementType()] }],
    ['Door No', DOOR_NO],
    ['Street', STREET],
    ['Area', AREA],
    ['City', CITY],
    ['State', STATE],
    ['Country', COUNTRY],
    ['PinCode', PINCODE],
    ['Higher Pension Applicability', HIGHER_PENSION_APPLICABILITY],
    ['Date Of Joining In EPF', DATE_OF_JOINING_IN_EPF],
    ['Spouse Name', SPOUSE_NAME],
    ['Scheme Certificate Number', PINCODE],
    ['Pension Payment Order Number', PENSION_PAYMENT_ORDER_NUMBER],
    ['Date Of Exit From Previous Employment', DATE_OF_EXIT_FROM_PREVIOUS_EMPLOYMENT],
    ['ESI Number', ESI_NUMBER],
    ['Month-Working Days', MONTH_WORKING_DAYS],
    ['Worked Days', WORKED_DAYS],
    ['Basic Pay', BASIC_PAY],
    ['HRA', HRA],
    ['LTA', LTA],
    ['Perq Allowance', PERQ_ALLOWANCE],
    ['Special Allowance', SPECIAL_ALLOWANCE],
    ['Telephone Allowance', TELEPHONE_ALLOWANCE],
    ['Food Allowance', FOOD_ALLOWANCE],
    ['Gross Earnings', GROSS_EARNINGS],
    ['LOP', LOP],
    ['TDS', TDS],
    ['EPS', EPS],
    ['Advance Pay', ADVANCE_PAY],
    ['Salary Due (Net Salary)', SALARY_DUE_NET_SALARY],
    ['Nature of work', NATURE_OF_WORK],
    ['Daily hours of work', DAILY_HOURS_OF_WORK],
    ['Intervals of rest', INTERVALS_OF_REST],
    ['Overtime Wages', OVERTIME_WAGES]
  ])
  override bulkImportApiFn: Function = null
  override formatEmployees: Function = (employees: any[]) => removeNullUndefinedEmpty(employees)
  override createAddress: Function = (row: any) => {
    return {
      address1: row?.doorno,
      address2: row?.street,
      address3: row?.area,
      city: row?.city,
      state: row?.state,
      country: row?.country,
      pin: row?.pin
    }
  }
  constructor(employeeService: EmployeeService, u: employeeAPIModel = null, webService: WebService) {
    super(employeeService, u, webService)
    this.bulkImportApiFn = (rowsToSave: any, webservice: WebService) => {
      const endPoint = ServiceUrlConstants.API_UPDATE_BULK_EMPLOYEE
      return webservice.post(endPoint, rowsToSave, null, [], false)
    }
    this.templateName = 'Employee_Update_Template.xlsx'
  }
}
